<script>
    const { layout, children } = $props();
</script>

{#if layout}
    {@const SvelteComponent = layout}
    <SvelteComponent>
        {@render children?.()}
    </SvelteComponent>
{:else}
    {@render children?.()}
{/if}
